import _extends from 'babel-runtime/helpers/extends';

import { fecthBasicList } from '@/api/material/basic';

export default {
  name: 'BasicPackSelector',

  componentName: 'BasicPackSelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      remoteLoading: false,
      baseOptions: []
    };
  },


  computed: {
    innerConfig: function innerConfig() {
      var params = _extends({
        filterable: true,
        placeholder: '请选择基础包',
        remote: true,
        'popper-class': 'm-custom-select'
      }, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    },
    formItemStyle: function formItemStyle() {
      var style = this.innerConfig.params.style || {};
      if (this.innerConfig.params.width) {
        style.width = this.innerConfig.params.width;
        if (typeof style.width === 'number') {
          style.width += 'px';
        }
      }
      return style;
    }
  },

  methods: {
    remoteBase: function remoteBase(query) {
      var _this = this;

      this.remoteLoading = true;
      fecthBasicList({
        page: 1,
        search_field: 'id_or_app_name',
        keyword: query
      }).then(function (res) {
        _this.remoteLoading = false;
        _this.baseOptions = res.data.data.list;
      }).catch(function () {
        _this.baseOptions = [];
        _this.remoteLoading = false;
      });
    }
  },

  mounted: function mounted() {
    if (this.baseOptions && !this.baseOptions.length) {
      this.remoteBase(this.formValue[this.innerConfig.prop]);
    }
  }
};